export default "__VITE_ASSET__7w8ElrJw__"